import React, { FC } from 'react'
import { TertiaryButton } from '@moonpig/launchpad-components'
import { system as s } from '@moonpig/launchpad-system'
import { styled } from '@moonpig/launchpad-utils'
import { spacing } from '@moonpig/launchpad-theme'
import { getClearFiltersEventLabel } from '../../store/helpers'
import { clearFiltersEvent } from '../../pages/SearchPage/events'
import {
  useSearchAnalytics,
  sanitizeContentType,
} from '../../pages/SearchPage/analytics'
import { FilterCategory, IntegerFilter } from '../../services/types/services'
import { useSearchStore } from '../../store/SearchStore'
import { useFindLocaleText } from '../../text-localisation'
import { FilterSource } from '../../types'

const StyledButton = styled(TertiaryButton)`
  ${s({
    typography: 'typeButtonLabel',
    color: 'colorInteractionTextLink',
    py: 5,
    px: 4,
    textAlign: 'right',
  })}
`
const StyledWrapper = styled.div`
  min-width: ${spacing(12)}px;
`

type Props = {
  level: number
  category?: FilterCategory | IntegerFilter
  type?: 'filters' | 'sort'
  hide: boolean
  source: FilterSource
}

export const ClearButton: FC<Props> = ({
  level,
  category,
  type = 'filters',
  source,
  hide,
}) => {
  const isLaunchpadAnalytics = useSearchAnalytics()

  const pageType = useSearchStore(store => store.pageContext.type)

  const clearLabel = getClearFiltersEventLabel([
    level === 0 ? { source } : { category, type, source },
  ])

  // Legacy event: apps/explore/find/src/store/middleware/trackEvent.ts
  const clearClickEvent = clearFiltersEvent()
    .withEventData({
      category: `${pageType} action`.toLowerCase(),
      label: clearLabel.toLowerCase(),
    })
    .withContentData({
      content_type: sanitizeContentType(
        `${pageType} action | clear filters | ${clearLabel}`,
      ),
    })

  const localiseText = useFindLocaleText()
  const clearFilters = useSearchStore(store => store.clearFilters)

  const onClear = () => {
    if (level === 0) {
      clearFilters({ source })
    } else {
      clearFilters({ category, type, source })
    }
  }

  return (
    <StyledWrapper>
      {!hide && (
        <StyledButton
          aria-label={localiseText('find.clear_selection')}
          events={
            isLaunchpadAnalytics ? { onClick: clearClickEvent } : undefined
          }
          onClick={() => onClear()}
        >
          <span>{localiseText('find.clear')}</span>
        </StyledButton>
      )}
    </StyledWrapper>
  )
}
